export default {
  listUsers: () => `/api/users/`,
  createUser: () => `/api/users/`,
  retrieveUser: id => `/api/users/${id}/`,
  updateUser: id => `/api/users/${id}/`,
  partialUpdateUser: id => `/api/users/${id}/`,
  destroyUser: id => `/api/users/${id}/`,
  listProfiles: () => `/api/profile/`,
  retrieveProfile: id => `/api/profile/${id}/`,
  listOrganizationInvites: () => `/api/partner_invites/`,
  createOrganizationInvite: () => `/api/partner_invites/`,
  retrieveOrganizationInvite: id => `/api/partner_invites/${id}/`,
  updateOrganizationInvite: id => `/api/partner_invites/${id}/`,
  partialUpdateOrganizationInvite: id => `/api/partner_invites/${id}/`,
  destroyOrganizationInvite: id => `/api/partner_invites/${id}/`,
  listPaymentMethods: () => `/api/payment_methods/`,
  createPaymentMethod: () => `/api/payment_methods/`,
  retrievePaymentMethod: id => `/api/payment_methods/${id}/`,
  updatePaymentMethod: id => `/api/payment_methods/${id}/`,
  partialUpdatePaymentMethod: id => `/api/payment_methods/${id}/`,
  destroyPaymentMethod: id => `/api/payment_methods/${id}/`,
  listAccountRoots: () => `/api/accounts/`,
  retrieveAccountRoot: id => `/api/accounts/${id}/`,
  listCustomerRoots: () => `/api/customers/`,
  retrieveCustomerRoot: id => `/api/customers/${id}/`,
  listCustomerInvites: () => `/api/customer_invites/`,
  createCustomerInvite: () => `/api/customer_invites/`,
  listMerchantOrganizations: () => `/api/merchants/`,
  createMerchantOrganization: () => `/api/merchants/`,
  retrieveMerchantOrganization: id => `/api/merchants/${id}/`,
  updateMerchantOrganization: id => `/api/merchants/${id}/`,
  partialUpdateMerchantOrganization: id => `/api/merchants/${id}/`,
  destroyMerchantOrganization: id => `/api/merchants/${id}/`,
  listCustomers: parent_lookup_merchant__id =>
    `/api/merchants/${parent_lookup_merchant__id}/customers/`,
  createCustomer: parent_lookup_merchant__id =>
    `/api/merchants/${parent_lookup_merchant__id}/customers/`,
  retrieveCustomer: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/customers/${id}/`,
  updateCustomer: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/customers/${id}/`,
  partialUpdateCustomer: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/customers/${id}/`,
  destroyCustomer: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/customers/${id}/`,
  listMerchantAccounts: parent_lookup_merchant__id =>
    `/api/merchants/${parent_lookup_merchant__id}/merchant_accounts/`,
  createMerchantAccount: parent_lookup_merchant__id =>
    `/api/merchants/${parent_lookup_merchant__id}/merchant_accounts/`,
  retrieveMerchantAccount: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/merchant_accounts/${id}/`,
  updateMerchantAccount: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/merchant_accounts/${id}/`,
  partialUpdateMerchantAccount: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/merchant_accounts/${id}/`,
  destroyMerchantAccount: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/merchant_accounts/${id}/`,
  listAccounts: parent_lookup_merchant_account__merchant__id =>
    `/api/merchants/${parent_lookup_merchant_account__merchant__id}/accounts/`,
  createAccount: parent_lookup_merchant_account__merchant__id =>
    `/api/merchants/${parent_lookup_merchant_account__merchant__id}/accounts/`,
  retrieveAccount: (parent_lookup_merchant_account__merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant_account__merchant__id}/accounts/${id}/`,
  updateAccount: (parent_lookup_merchant_account__merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant_account__merchant__id}/accounts/${id}/`,
  partialUpdateAccount: (parent_lookup_merchant_account__merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant_account__merchant__id}/accounts/${id}/`,
  destroyAccount: (parent_lookup_merchant_account__merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant_account__merchant__id}/accounts/${id}/`,
  listBusinessOwners: parent_lookup_merchant__id =>
    `/api/merchants/${parent_lookup_merchant__id}/business_owners/`,
  createBusinessOwner: parent_lookup_merchant__id =>
    `/api/merchants/${parent_lookup_merchant__id}/business_owners/`,
  retrieveBusinessOwner: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/business_owners/${id}/`,
  updateBusinessOwner: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/business_owners/${id}/`,
  partialUpdateBusinessOwner: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/business_owners/${id}/`,
  destroyBusinessOwner: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/business_owners/${id}/`,
  listMessageTemplates: parent_lookup_merchant__id =>
    `/api/merchants/${parent_lookup_merchant__id}/message_templates/`,
  createMessageTemplate: parent_lookup_merchant__id =>
    `/api/merchants/${parent_lookup_merchant__id}/message_templates/`,
  retrieveMessageTemplate: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/message_templates/${id}/`,
  updateMessageTemplate: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/message_templates/${id}/`,
  partialUpdateMessageTemplate: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/message_templates/${id}/`,
  destroyMessageTemplate: (parent_lookup_merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant__id}/message_templates/${id}/`,
  listHeartbeats: () => `/`,
  listtransaction_report_urls: () => `/api/reports/`,
  listInvites: () => `/api/partner-invite/`,
  createInvite: () => `/api/partner-invite/`,
  updateInvite: () => `/api/partner-invite/`,
  createMerchantUser: () => `/api/signup/`,
  payAccountRoot: id => `/api/accounts/${id}/pay/`,
  createTwilioMessage: () => `/api/twilio/messages/`,
  createPaymentIframeCredsMerchantOrganization: id =>
    `/api/merchants/${id}/create_payment_iframe_creds/`,
  sendMessagesMerchantOrganization: id => `/api/merchants/${id}/send_messages/`,
  submitToPropayMerchantOrganization: id =>
    `/api/merchants/${id}/submit_to_propay/`,
  sendMessageAccount: (parent_lookup_merchant_account__merchant__id, id) =>
    `/api/merchants/${parent_lookup_merchant_account__merchant__id}/accounts/${id}/send_message/`,
  createBlytzTokenObtainPair: () => `/api/token/`,
  createTokenRefresh: () => `/api/token/refresh/`,
  createTwilioCall: () => `/api/twilio/calls/`,
  listCustomerMessages: (parent_lookup_merchant__id, id) => `/api/merchants/${parent_lookup_merchant__id}/customers/${id}/messages/`
}
